export * from './src/dispatcher';
export * from './src/ng2';
export * from './src/reducer';
export * from './src/state';
export * from './src/store';
export * from './src/utils';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/store/index.js
// module id = 27
// module chunks = 4